var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68082 13.8189C2.80092 13.9399 2.95899 14 3.11706 14C3.27498 14 3.43304 13.9391 3.55404 13.8189L8.50009 8.87283L13.4465 13.8189C13.5668 13.9399 13.7247 14 13.8828 14C14.0399 14 14.1979 13.9391 14.3189 13.8189C14.56 13.5778 14.56 13.1869 14.3189 12.9458L9.37302 7.99989L14.3189 3.05405C14.56 2.8128 14.56 2.42192 14.3189 2.18082C14.0778 1.93973 13.6869 1.93973 13.4458 2.18082L8.49988 7.12674L3.55404 2.18082C3.3128 1.93973 2.92192 1.93973 2.68082 2.18082C2.43973 2.42192 2.43973 2.8128 2.68082 3.05405L7.6269 7.99972L2.68082 12.9458C2.43973 13.1869 2.43973 13.5778 2.68082 13.8189Z",
    fill: "#828EE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdelete);
export default __webpack_public_path__ + "static/media/idelete.9b07d400ce0e9d6116a929ba9f61bad2.svg";
export { ForwardRef as ReactComponent };